/**
 * 从 Unicode 编码值（比如 U+1F603）中获取代码点
 * @param unicode 编码
 * @returns 代码点
 */
export const getCodePointFromUnicode = (unicode: string) => {
  return parseInt(unicode.substring(2), 16)
}

/**
 * 从字符串（比如 😀）中获取代码点
 *
 * @param str 字符串
 * @returns 代码点
 */
export const getCodePointFromString = (str: string) => {
  return str.codePointAt(0)
}

/**
 * 获取字符串的 unicode 编码值
 *
 * @param str 字符串
 * @returns unicode
 */
export const getUnicodeFromString = (str: string) => {
  return `U+${str.codePointAt(0)?.toString(16)}`
}

/**
 * Unicode 编码转换为 HTML 实体
 *
 * @param unicode 编码
 * @returns 字符实体
 */
export const unicode2HtmlEntity = (unicode: string) => {
  return '&#' + getCodePointFromUnicode(unicode) + ';'
}
